module.exports = __webpack_public_path__ + "media/mypage/images/sparkle-favicon-b989766d06dfc255406971d5b22f9e6e.png";